const languages = {
  spanish: 'es',
  english: 'en',
  default: 'en',
  fallback: 'en',
};

export default languages;